import Header from '../../components/Header'

import Footer from '../../components/Footer'
import * as S from '../../styles/page-profile'

import { Breadcrumb, BreadcrumbItem } from '../../styles/breadcrumb'
import ProfileSideMenu from '../../components/MenuProfile'
import { ProfileTitle } from '../../components/FormChangePassword/styles'

import { useEffect } from 'react'

import Pedido from '../../components/MyOrders'
import { useLocation, useParams } from 'react-router-dom'
import { getLocalStorageLog } from '../../utils/traceLogAcessos'

function MeusPedidosItem() {
  const { idPedido }: any = useParams()

  const location = useLocation()

  //Redirect para Meus Pedidos contendo o número do pedido digitado na URL
  useEffect(() => {
    getLocalStorageLog(location.pathname)

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <>
      <Header />
      <S.Profile className="perfil">
        <S.PageContent className="page-content">
          <S.Wrapper className="wrapper">
            <S.ColGroup className="col-group">
              <ProfileSideMenu />
              <S.ProfileContent className="col-9">
                {/* Área para inserir os novo componentes criados para ficar ao lado do menu lateral de perfil */}
                <Breadcrumb>
                  <BreadcrumbItem>Inicio</BreadcrumbItem>
                  <BreadcrumbItem>Meus Pedidos</BreadcrumbItem>
                  <BreadcrumbItem>Pedido Nº {idPedido}</BreadcrumbItem>
                </Breadcrumb>
                <ProfileTitle>Pedido Nº {idPedido}</ProfileTitle>

                <Pedido />

                {/* Fim da área de conteúdo da página */}
              </S.ProfileContent>
            </S.ColGroup>
          </S.Wrapper>
        </S.PageContent>
      </S.Profile>
      <Footer />
    </>
  )
}

export default MeusPedidosItem
